import axios from 'axios';

import type { RecentEntryKind, UserPreferencesResponse } from './get-user-preferences';

export type SaveRecentParams = {
	kind: RecentEntryKind,
	id: string,
	customerEmail: string,
	label?: string,
	getToken: () => Promise<string>,
	setState?: (data: UserPreferencesResponse) => void,
	setError?: (error: string) => void
};

// Records what the caller just opened so the portal can offer it back on any machine they sign in from.
// Scoped server-side to the caller's own identity from the JWT -- no designer email param (see post-recent.epo.ts).
export const saveRecent = async (params: SaveRecentParams): Promise<[UserPreferencesResponse | null, string | null]> => {
	const { kind, id, customerEmail, label, getToken, setState, setError } = params;

	try {
		const token = await getToken();
		const response = await axios.post(`${import.meta.env.VITE_API_URL}/preferences/recents`, { kind, id, customerEmail, label }, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		// A build of the API without the recents route answers 204 with an empty body, which is not an error to axios
		if (response.status !== 200 || !response.data?.recents) {
			console.warn('[save-recent] unexpected response', response.status, response.data);
			const message = `Error recording recent (status ${response.status})`;
			if (setError) setError(message);
			return [null, message];
		}

		if (setState) setState(response.data);
		return [response.data, null];
	} catch (error) {
		console.warn('[save-recent] request failed', error);
		if (setError) setError('Error recording recent');
		return [null, 'Error recording recent'];
	}
};
